<template>
    <div class="wrapper tab-insurance">
        <header>
            <span class="new-headline-md text-centered text-bold">Lassen Sie uns Ihre Kostenübernahme sichern. <br>Wo sind Sie versichert?</span>

            <p class="new-text-xl text-centered text-color-default">Wir prüfen direkt, ob Ihre Krankenkasse die Kosten für Ihr Programm zu 100% übernimmt.</p>
        </header>

        <div class="insurance-search">
            <div class="input-wrapper form-input-text input-has-full-border search-wrapper" @focusout="handleFocusOut">
                <span class="material-symbols-rounded">search</span>
                <input
                    id="insurance_company"
                    class="full-border"
                    type="text"
                    placeholder="Krankenkasse suchen"
                    autocomplete="off"
                    v-model="searchValue"
                    @click="isActive = true"
                />

                <div v-if="insuranceCompanies && isDropdownActive" class="insurance-companies-dropdown">
                    <ul class="no-list-style">
                        <li v-for="company in companiesArray" :key="company.id">
                            <a href="#" :data-id="company.id" @click.prevent="select(company)">{{ company.name }}</a>
                        </li>

                        <li v-if="companiesArray.length === 0">
                            <span>Nichts gefunden</span>
                        </li>
                    </ul>
                </div>
            </div>

            <form-input-error v-if="error" :error="error"></form-input-error>

            <div class="btn-group">
                <v-button label="Kostenübernahme prüfen" @onClick="confirm" :disabled="!selected"></v-button>
            </div>
        </div>

        <div class="pkv-note">
            <strong class="new-text-md">Haben Sie eine PKV?</strong>
            <p class="new-text-md text-color-default">Die Kosten werden von vielen privaten Krankenversicherungen übernommen. Fragen Sie Ihre private Krankenversicherung, ob und wie die Kosten für Vitadio erstattet werden können. <a href="/kontakt?pkv-self-payer" class="text-link">Kontaktieren Sie uns</a> für weitere Informationen.</p>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                insuranceCompanies: null,
                searchValue: '',
                selected: null,
                isActive: false,
                error: null
            }
        },

        mounted() {
            this.fetchCompanies()
        },

        computed: {
            companiesArray() {
                let companies = _.orderBy(this.insuranceCompanies, ['name'], ['asc'])

                if (this.searchValue !== '' && this.searchValue) {
                    companies = companies.filter((item) => {
                        return item.name.toLowerCase().includes(this.searchValue.toLowerCase())
                    })
                }

                return companies
            },

            isDropdownActive() {
                if (this.selected && this.searchValue === this.selected.name) {
                    return false
                }

                return this.searchValue !== '' || this.isActive
            }
        },

        watch: {
            searchValue(value) {
                if (this.selected && value !== this.selected.name) {
                    this.selected = null
                }
            }
        },

        methods: {
            fetchCompanies() {
                axios
                    .get('api/de-insurers')
                    .then((response) => {
                        this.insuranceCompanies = response.data.data
                    })
                    .catch((error) => {
                        console.log(error.response)
                    })
            },

            select(company) {
                this.selected = company
                this.searchValue = company.name
                this.isActive = false
                this.error = null
            },

            confirm() {
                if (!this.selected) {
                    this.error = 'Bitte wählen Sie Ihre Krankenkasse aus der Liste aus.'

                    return
                }

                this.$emit('answer', this.selected)
            },

            handleFocusOut(event) {
                if ((this.searchValue === '' && !event.relatedTarget) || (event.relatedTarget && !event.relatedTarget.dataset)) {
                    setTimeout(() => {
                        this.isActive = false
                    }, 150)
                }
            }
        }
    }
</script>
